import { FunctionComponent, useCallback, useContext, useMemo, useState } from "react";
import Button from "./Button";

interface IProps {
    error: Error;
    resetErrorBoundary(): void;
}

const ErrorFallback: FunctionComponent<IProps> = (props) => {
	const { error } = props;
	const [showDetails, setShowDetails] = useState(false);

	const buttonText = useMemo(() => {
		return showDetails ? "Hide details" : "Show details";
	}, [showDetails]);
	const toggleDetails = useCallback(() => {
		setShowDetails(x => !x);
	}, []);
	const details = useMemo(() => {
		if (!showDetails) { return null; }
		return <>
			<p>{error.message}</p>
			{error.stack?.split('\n').map((line, index) => {
				return <p key={index}>{line}</p>
			})}
		</>
	}, [error.message, error.stack, showDetails]);

	return <div role="alert" style={{ padding: "0px 5px 5px 5px" }}>
		<h1>Something went wrong</h1>
		<Button color="Blue" size="Medium" level="Secondary" onClick={toggleDetails} width={134}>{buttonText}</Button>
		{details}
	</div>;
}

export default ErrorFallback;